module.exports = __webpack_public_path__ + "static/js/moment-timezone-with-data-2012-2022.static.js";